import {useState} from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography,} from "@mui/material";
import styles from "./styles";
import CustomTabs from "../../../Tabs";
import {CustomTabPanel} from "../../../../../helpers";
import FormVariant from "./forms";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useWindowSize} from "../../../../../shared/hooks/useWindowSize";

const Content = () => {
  const { t } = useTranslation();
  const { width } = useWindowSize();

  const data = useSelector((state: any) => state.kyb.kyb_status_data);

  const [isOpen, setIsOpen] = useState(true);

  const [tab, setTab] = useState(0);
  const tabs = [t("company"), "Identity", "Address", "Documents"];

  const isMobile = width <= 1024;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Accordion variant="outlined" sx={styles.container} expanded={isOpen}>
      <AccordionSummary
        sx={styles.header}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Box sx={styles.headerContent}>
          <Typography variant="h6">{t("company")}</Typography>
          {isOpen && !isMobile && (
            <Box sx={{ paddingRight: `${isMobile ? "16px" : "32px"}` }}>
              <CustomTabs value={tab} handleChange={handleChange} tabs={tabs} />
            </Box>
          )}
        </Box>
      </AccordionSummary>
      {isOpen && isMobile && (
        <Box sx={{ 
        padding: `${isMobile ? "0 5px" : "0 32px"}`,

         margin:"-25px 0 32px 0",
         ' & .MuiTabs-flexContainer': {
          justifyContent:'space-between',
          gap: '0',
          }}}>
          <CustomTabs value={tab} handleChange={handleChange} tabs={tabs} />
        </Box>
      )}
      <AccordionDetails>
        <CustomTabPanel value={tab} index={0}>
          <Box sx={styles.content}>
            <FormVariant type="first_tier" data={data} />
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={tab} index={1}>
          <Box sx={styles.content}>
            <FormVariant type="second_tier" data={data} />
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={tab} index={2}>
          <Box sx={styles.content}>
            <FormVariant type="third_tier" data={data} />
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={tab} index={3}>
          <Box sx={styles.content}>
            <FormVariant type="fourth_tier" data={data} />
          </Box>
        </CustomTabPanel>
      </AccordionDetails>
    </Accordion>
  );
};

export default Content;
